<template>
  <b-container class="my-5">
    <b-row>
      <b-col xl="12">
        <b-card no-body>
          <h3 class="card-header bg-white">Consultorio 1</h3>
          <b-card-body>
            <div class="text-center mb-3 d-flex justify-content-center" v-if="loadingOffice">
              <b-spinner
                label="Loading"
              ></b-spinner>
            </div>
            <h5 class="text-primary">Listado Médico</h5>
            <p>Somos un directorio médico en linea que concentra médicos de todas las especialades a lo largo de México. Aquí podrás encontrar el médico especialista que necesitas cerca de tu hogar o trabajo.</p>
            <h5 class="text-primary">¿Por qué usarnos?</h5>
            <p>Nuestra meta es conectar médicos y pacientes a lo largo de todo México. Si eres nuevo en la ciudad, nunca habias necesitado un médico o quieres encontrar un médico para algún amigo o familiar, <b>Listado Médico</b> es el servicio que te puede ayuadar.</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col xl="12">
        <adsense
          ad-slot="9585150092"
          ad-format="auto"
          ad-client="ca-pub-1844310477126911"
          ad-style="display:block">
        </adsense>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Adsense from '@/components/Adsense'

export default {
  components: { Adsense },
  name: 'About',
  data () {
    return {
      loadingOffice: true,
      offices: {
        data: [],
        length: 0
      }
    }
  },
  mounted: async function () {
    try {
      await this.$http.get('/offices')
    } catch (error) {
      this.$bvToast.toast('El error que sucedió fue :::', {
        title: 'Error recuperando consultorios',
        autoHideDelay: 5000
      })
    }
  }
}
</script>
